// Disclosure özet kartları (TODO-KPI-08): % hazır (ilerleme çubuğu) · gereken · eksik · sette olmayan.
import type { KpiDisclosureSummary } from "@mahir/shared";
import { KPI_TARGETS_COPY, readyTone, targetToneColor } from "../../../lib/kpi-targets-ui";

const C = KPI_TARGETS_COPY.disclosure;

function Card({
  label,
  value,
  hint,
  color,
}: {
  label: string;
  value: string;
  hint?: string;
  color?: string | undefined;
}): JSX.Element {
  return (
    <div
      className="rounded-xl px-4 py-3"
      style={{ background: "var(--color-surface)", border: "1px solid var(--color-border)" }}
    >
      <div
        style={{
          fontSize: "0.7rem",
          fontWeight: 700,
          letterSpacing: "0.06em",
          textTransform: "uppercase",
          color: "var(--color-text-3)",
        }}
      >
        {label}
      </div>
      <div
        className="text-2xl mt-1"
        style={{
          color: color ?? "var(--color-text)",
          fontVariantNumeric: "tabular-nums",
          fontWeight: 600,
        }}
      >
        {value}
      </div>
      {hint ? (
        <div className="text-xs mt-1" style={{ color: "var(--color-text-2)" }}>
          {hint}
        </div>
      ) : null}
    </div>
  );
}

export function DisclosureCards({ summary }: { summary: KpiDisclosureSummary }): JSX.Element {
  const color = targetToneColor(readyTone(summary));
  return (
    <div
      className="grid gap-3 mb-4"
      style={{ gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))" }}
    >
      <div
        className="rounded-xl px-4 py-3"
        style={{ background: "var(--color-surface)", border: "1px solid var(--color-border)" }}
      >
        <div
          style={{
            fontSize: "0.7rem",
            fontWeight: 700,
            letterSpacing: "0.06em",
            textTransform: "uppercase",
            color: "var(--color-text-3)",
          }}
        >
          {C.cards.ready} · {summary.standard} {summary.year}
        </div>
        <div
          className="text-2xl mt-1"
          style={{ color, fontWeight: 600, fontVariantNumeric: "tabular-nums" }}
        >
          %{summary.readyPct}
        </div>
        <div
          role="progressbar"
          aria-valuemin={0}
          aria-valuemax={100}
          aria-valuenow={summary.readyPct}
          aria-label={`Hazırlık %${summary.readyPct}`}
          className="mt-2"
          style={{
            height: 8,
            borderRadius: 999,
            background: "var(--color-bg)",
            border: "1px solid var(--color-border)",
            overflow: "hidden",
          }}
        >
          <div style={{ width: `${summary.readyPct}%`, height: "100%", background: color }} />
        </div>
        <div className="text-xs mt-1" style={{ color: "var(--color-text-2)" }}>
          {C.readyHint(summary.filled, summary.notMeasured, summary.required)}
        </div>
      </div>
      <Card
        label={C.cards.required}
        value={String(summary.required)}
        hint={`${summary.inSet} veri setinde`}
      />
      <Card
        label={C.cards.missing}
        value={String(summary.missing)}
        color={summary.missing > 0 ? "var(--color-warning-text)" : undefined}
      />
      <Card
        label={C.cards.missingFromSet}
        value={String(summary.missingFromSet)}
        color={summary.missingFromSet > 0 ? "var(--color-warning-text)" : undefined}
      />
    </div>
  );
}
